/*
 * Author M. Atoar Rahman
 * Title: D3 Report
 * Description: Index for D3 Report
 * Date: 05/06/2022
 */

import { Button, Card } from 'react-bootstrap';
import { useDonation } from './ContextAPI';
import DataTable from './DataTable';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';

export default function Index() {
    const { show, setShow, setIsSubmitted, showPdf } = useDonation();
    const createHander = () => {
        setShow(true);
        setIsSubmitted(false);
    };

    const backHander = () => {
        setShow(false);
    };

    return showPdf ? (
        <PrintIndex />
    ) : (
        <Card>
            <Card.Header className="cardHeader">
                <h3>Stock Donation</h3>
                {show ? (
                    <div>
                        <Button onClick={() => backHander()} className="btnInfo" variant="primary">
                            Back to List
                        </Button>
                    </div>
                ) : (
                    <div>
                        <Button
                            onClick={() => createHander()}
                            className="btnInfo"
                            variant="primary"
                        >
                            Donate Now
                        </Button>
                    </div>
                )}
            </Card.Header>
            <Card.Body>{show ? <FormInfo /> : <DataTable />}</Card.Body>
        </Card>
    );
}
